import client from './client'

let countdownService = {}

countdownService.getEventTime = async function() {
  try {
    const res = await client.get('/options/get-event-time/')
    return res.data
  } catch (error) {
    return error
  }
}

export default countdownService
